/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A schema for a CredentialClaimValue that can be of various kinds.
 */
export type CredentialClaimValue =
    | Truvity.CredentialClaimValue.Array
    | Truvity.CredentialClaimValue.Boolean
    | Truvity.CredentialClaimValue.Date_
    | Truvity.CredentialClaimValue.Datetime
    | Truvity.CredentialClaimValue.File_
    | Truvity.CredentialClaimValue.Link
    | Truvity.CredentialClaimValue.Number
    | Truvity.CredentialClaimValue.String
    | Truvity.CredentialClaimValue.Struct;

export namespace CredentialClaimValue {
    export interface Array extends Truvity.ArrayClaimValue {
        kind: 'ARRAY';
    }

    export interface Boolean extends Truvity.BooleanClaimValue {
        kind: 'BOOLEAN';
    }

    export interface Date_ extends Truvity.DateClaimValue {
        kind: 'DATE';
    }

    export interface Datetime extends Truvity.DateTimeClaimValue {
        kind: 'DATETIME';
    }

    export interface File_ extends Truvity.FileClaimValue {
        kind: 'FILE';
    }

    export interface Link extends Truvity.LinkClaimValue {
        kind: 'LINK';
    }

    export interface Number extends Truvity.NumberClaimValue {
        kind: 'NUMBER';
    }

    export interface String extends Truvity.StringClaimValue {
        kind: 'STRING';
    }

    export interface Struct extends Truvity.StructClaimValue {
        kind: 'STRUCT';
    }
}
